function Result({ correct, questions }) {
  return (
    <div className="result">
      <h2>
        {correct === questions.length ? (
          <>
            <p>Поздравляем! 😀</p>
            <p>Вы ответили на все вопросы! 🔥</p>
          </>
        ) : (correct * 100) / questions.length >= 50 ? (
          <>
            <p>Неплохой результат! 🙂</p>
            <p>Вы дали более половины правильных ответов! 👍</p>
          </>
        ) : (
          <>
            <p>Стоит постараться 😐 </p>
            <p>Пока у вас меньше половины правильных ответов 😔</p>
          </>
        )}
        <p className="result-text">
          Ваш результат: {correct} из {questions.length}
        </p>
      </h2>
      <a href="/">
        <button>Начать тест заново</button>
      </a>
    </div>
  );
}
export default Result;
